<div class="absolute w-[100vw] h-[100vh] flex items-center justify-center">
  <p-blockUI [blocked]="isLoading"></p-blockUI>
  <p-progressSpinner
    *ngIf="isLoading"
    styleClass="w-16 h-16"
    strokeWidth="8"
    fill="var(--surface-ground)"
    animationDuration=".5s"></p-progressSpinner>
</div>
